import { useEffect, useState } from "react"
import Button from "aldoo-ra/Button"
import Typography from "aldoo-ra/Typography"
import config from "aldoo-ra/Config"
import { getConsent, isConsentRequired, setConsent } from "aldoo-ra/Tracking/consent"
const { TRACKING_GDPR } = config

/**
 * Cookie consent banner. Shown once until the visitor accepts or declines;
 * the choice drives consent mode on the ad tags (aldoo-ra/Tracking/consent).
 *
 * Bottom sheet on phones, paper card in the bottom-left corner on larger
 * screens, styled with the site's own tokens and button variants.
 */
export default function CookieConsent() {
  const [visible, setVisible] = useState(false)

  // Decide on the client only: the Head consent script has already set
  // window.__consentRequired from the visitor's country (consent-geo), so
  // there is no pageContext dependency here — error pages included.
  useEffect(() => {
    if (!TRACKING_GDPR) return
    if (!isConsentRequired()) return
    if (getConsent()) return
    setVisible(true)
  }, [])

  if (!visible) return null

  const decide = (value) => {
    setConsent(value)
    setVisible(false)
  }

  return (
    <div
      role="dialog"
      aria-live="polite"
      aria-label="Cookie consent"
      className="fixed inset-x-0 bottom-0 z-[60] sm:inset-x-auto sm:left-4 sm:bottom-4 sm:max-w-md"
    >
      <div
        className="bg-paper text-text border-t sm:border border-bordered shadow-2xl sm:rounded-3xl px-5 pt-5 sm:p-6 flex flex-col gap-4"
        style={{ paddingBottom: "max(1.25rem, env(safe-area-inset-bottom))" }}
      >
        <div className="flex flex-col gap-1.5">
          <Typography variant="body1_medium" className="mb-0">
            We value your privacy
          </Typography>
          <Typography variant="txt_dim" className="leading-relaxed">
            We use cookies to measure our ads and improve Aldoo Snap. Accept or
            decline — the site works the same either way.{" "}
            <a
              href="/privacy-policy"
              className="text-primary hover:text-primary_dk hover:underline whitespace-nowrap"
            >
              Privacy policy
            </a>
          </Typography>
        </div>

        <div className="flex flex-col-reverse sm:flex-row gap-2 sm:justify-end">
          <Button variant="secondary" className="w-full sm:w-auto" onClick={() => decide("denied")}>
            Decline
          </Button>
          <Button variant="primary" className="w-full sm:w-auto" onClick={() => decide("granted")}>
            Accept
          </Button>
        </div>
      </div>
    </div>
  )
}
